import { render } from "./Hamburger.vue?vue&type=template&id=4683785b&scoped=true"
import script from "./Hamburger.vue?vue&type=script&lang=js"
export * from "./Hamburger.vue?vue&type=script&lang=js"

import "./Hamburger.vue?vue&type=style&index=0&id=4683785b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4683785b"

export default script